export const ONE_MINUTE = 60 * 1000;
export const THIRTY_MINUTES = 30 * ONE_MINUTE;
